// ------------------------------------
// props 輸入需求 : 
// props.toggleDropdown : boolean                   (react usestate)
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            ( dropdown 真正的選擇內容 : lng 種類 )
// props.returndata : function( params: str )       ( 帶入選取值 string )
// ------------------------------------

import React from 'react';

const DropdownLNG = (props) => {

    const Parrel = props.data.keys.map((k, index)=>{
        return (
            <div key={index+k} className="fx-d-c">{index===0? 
                <div className="parallel first fx-ccc pad-3 b pad-5 t" >
                    <div className="skew-revese unselc">
                        {k}
                    </div>
                </div>:
                <div className="parallel second slash pad-3 b pad-5 t" onClick={e=>props.setReturnLng(e.target.id)} id={k}>
                    <div className="skew-revese unselc">
                        {(k==="English (US)")? "English":k}
                    </div>
                </div>
                }           
            </div>
            )
        }
    )

    return (
        <div onClick={props.hide} className="pos-f z-1 wid-full hig-full top-0 left-0">
            <div className="pos-a r-0 mar t-100 r-45" onClick={e => e.stopPropagation()}>
                <div className="fx-d-r skew parallel-before">
                    {Parrel}
                </div>
            </div>
        </div>
    )
}

export default DropdownLNG;